
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'CustomerSearchCustomItem',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private servicerOptions = [];
  private typeOptions = [{
    value: '1',
    label: '公司'
  }, {
    value: '2',
    label: '个人'
  }]

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
